import React, { useEffect } from 'react'
import { WooMenuItem, WooNotesPopupMenu } from './WooNotes/WooNotesPopupMenu'
import { FolderNode } from './WooNotes/folders'
import { useWindowDimensions } from './hooks/useWindowDimensions'

export type ContextMenuState =
  | {
      isOpen: true
      x: number
      y: number
      target: 'node'
      nodeId: string
      nodeKind: 'folder' | 'text'
    }
  | {
      isOpen: true
      x: number
      y: number
      target: 'root'
    }

type Props = {
  state: ContextMenuState | null
  node?: FolderNode
  onClose: () => void
  onAction: (ctx: ContextMenuState, action: any) => void
  canCreateNodes?: boolean
}

export function ContextMenu({ state, node, onClose, onAction, canCreateNodes }: Props) {
  const { height: windowHeight } = useWindowDimensions()

  useEffect(() => {
    if (!state?.isOpen) return

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }

    const onMouseDown = () => onClose()

    window.addEventListener('keydown', onKeyDown)
    //window.addEventListener('mousedown', onMouseDown)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
      //window.removeEventListener('mousedown', onMouseDown)
    }
  }, [state, onClose])

  //if (!state?.isOpen) return null

  const isRoot = state?.target === 'root'
  const isFolder = state?.target === 'node' && state.nodeKind === 'folder'
  const isText = state?.target === 'node' && state.nodeKind === 'text'

  const y = state?.y ?? -1000
  const anchor =  y/windowHeight > 0.75 ? 'top-left' : 'bottom-left'
  //console.log(`windowHeight=${windowHeight} y=${y}  v=${y/windowHeight}`)

  return (
    <WooNotesPopupMenu
      positionOverride={{
        x: state?.x ?? -1000,
        y,
      }}
      anchor={anchor}
      open={!!state?.isOpen && !!state?.x && !!state?.y}
      onClose={onClose}
      items={
        [
          ...(isRoot || isFolder
            ? [
                {
                  id: 'createFolder',
                  label: 'Create folder',
                  subtitle: isRoot ? '... in root' : node ? `... in ${node.name}` : undefined,
                  icon: '📁',
                  onSelect: () => {
                    onAction(state, { type: 'create-folder' })
                  },
                  disabled: canCreateNodes === false,
                },
                {
                  id: 'createNote',
                  label: 'Create note',
                  subtitle: isRoot ? '... in root' : node ? `... in ${node.name}` : undefined,
                  icon: '📝',
                  onSelect: () => onAction(state, { type: 'create-note' }),
                  disabled: canCreateNodes === false,
                },
              ]
            : []),

          ...(isText || isFolder
            ? [
                {
                  id: 'rename',
                  label: 'Rename',
                  subtitle: node ? `... ${node.name}` : undefined,
                  icon: '✏️',
                  disabled: node?.isLocked,
                  onSelect: () => onAction(state, { type: 'rename' }),
                },
                {
                  id: 'remove',
                  label: 'Remove',
                  subtitle: node ? `... ${node.name}` : undefined,
                  icon: '❌',
                  danger: true,
                  disabled: node?.isLocked,
                  onSelect: () => onAction(state, { type: 'delete' }),
                },
              ]
            : []),
        ] as WooMenuItem[]
      }
    />
  )
}
